import {
  Modal,
  Select,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { EditableList } from '../../../compnents/list/EditableList'
import { RecordColumns } from './column'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getExcuteTableList } from '../toBeCompletedTreatment/toBeCompletedTreatmentSlice'
import moment from 'moment'
import { LookModal } from '../lookModal'
import { ExcuteModal } from './ExecutionModal'

const { Option } = Select

export const ExcuteDetailModal = (props: {
  isModalVisible: boolean
  id: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [list, setList] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [coherentVideo, setCoherentVideo] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isExcuteModalVisible, setIsExcuteModalVisible] = useState(false)

  const [treatmentServiceName, setTreatmentServiceName] = useState<any>()

  useEffect(() => {
    if (props?.isModalVisible) {
      getList()
    }
  }, [props?.isModalVisible])

  const getList = () => {
    dispatch(getExcuteTableList({ id: props?.id }))
      .then(unwrapResult)
      .then((res: any) => {
        setTreatmentServiceName(res?.treatmentServiceName)
        setList(res?.medicalStationItemList.sort(
          (a: any, b: any) =>
            moment(b.executeTime).unix() - moment(a.executeTime).unix()
        ))
      })
  }

  return (
    <>
      <Modal
        width={1200}
        title={'执行记录'}
        visible={props.isModalVisible}
        footer={null}
        bodyStyle={{
          height: 650,
          padding: 16,
        }}
        destroyOnClose
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <EditableList
          scroll={{ y: (list?.length > 10 && 400) as any }}
          bordered
          pagination={false}
          page={{
            items: list || [],
            current: 1,
            size: 10,
            total: 0,
          }}
          columns={RecordColumns((text, id, coherentVideo) => {
            setId(id)
            if (text == "look") {
              setCoherentVideo(coherentVideo);
              setIsModalVisible(true);
            } else if (text == "change") {
              setIsExcuteModalVisible(true)
            }
          })}
        />
      </Modal>
      <LookModal
        isModalVisible={isModalVisible}
        id={id}
        fileList={coherentVideo}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        onOk={() => {
          setIsModalVisible(false);
        }}
      />
      {/* 执行 */}
      <ExcuteModal
        edit={true}
        singleState={true}
        treatmentServiceName={treatmentServiceName}
        id={id}
        isModalVisible={isExcuteModalVisible}
        onOk={(() => {
          setIsExcuteModalVisible(false)
          setId("")
          getList()
        })}
        onCancel={(() => {
          setIsExcuteModalVisible(false)
          setId("")
        })}
      />
    </>
  )
}
